import React, { useEffect, useState } from 'react';
import RichContent from '../components/RichContent';
import LangToggle, { useSiteLang } from '../components/LangToggle';
import ShareButton from '../components/ShareButton';

const UI = {
  fr: { title: 'À propos', loading: 'Chargement...', error: 'Impossible de charger la page pour le moment.', notTranslated: null, label: 'Langue de la page' },
  en: { title: 'About me', loading: 'Loading...', error: 'This page could not be loaded right now.', notTranslated: 'This page is not available in English yet — here is the French version.', label: 'Page language' },
};

export default function About() {
  const [page, setPage] = useState(null);
  const [error, setError] = useState(false);
  const [lang, setLang] = useSiteLang();
  const t = UI[lang];

  useEffect(() => {
    fetch('/api/pages/about')
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(setPage)
      .catch(() => setError(true));
  }, []);

  const hasEn = page && (page.content_en || '').replace(/<[^>]*>/g, '').trim() !== '';
  const showEn = lang === 'en' && hasEn;
  const title = page ? (lang === 'en' ? (page.title_en || (hasEn ? t.title : page.title)) : page.title) : t.title;
  const html = page ? (showEn ? page.content_en : page.content) : '';

  return (
    <div className="page-layout fade-in" lang={showEn || lang === 'fr' ? lang : 'fr'}>
      <div className="cv-lang-row page-lang-row">
        <LangToggle lang={lang} onChange={setLang} label={t.label} />
        <ShareButton lang={lang} variant="icon" title={lang === 'en' ? 'About Fatima-Zahra Moussaid' : 'À propos de Fatima-Zahra Moussaid'} />
      </div>
      <h1 className="page-title" lang={lang === 'en' && page && page.title_en ? 'en' : undefined}>{title}</h1>
      {lang === 'en' && page && !hasEn && <p className="page-lang-notice" lang="en">{t.notTranslated}</p>}
      {error ? <p>{t.error}</p>
        : !page ? <p>{t.loading}</p>
        : <RichContent key={showEn ? 'en' : 'fr'} className="page-content" html={html} />}
    </div>
  );
}
